import httpClient from "./httpClient";

const languagesRef = lang => httpClient.get(`/languages/${lang}`);

const systemsRef = lang => httpClient.get(`/systems/${lang}`);

const countriesRef = lang => httpClient.get(`/countries/${lang}`);

const citiesRef = lang => httpClient.get(`/cities/${lang}`);

const referencesRef = lang => httpClient.get(`/references/${lang}`);

const attributeTypeRef = lang => httpClient.get(`/attributeTypes/${lang}`);

const referenceSpecific = (id, lang) =>
  httpClient.get(`/references/${id}/${lang}`);

export {
  languagesRef,
  systemsRef,
  countriesRef,
  citiesRef,
  referencesRef,
  attributeTypeRef,
  referenceSpecific
};
